import config from 'config'

export const isExtensionInstalled = () => {
  return new Promise((resolve, reject) => {
    window.chrome.runtime.sendMessage(config.HYFY_EXTENSION_ID, { message: 'ping' }, response => {
      if (response && response.res) {
        resolve(response.res === 'pong')
      } else {
        resolve(false)
      }
    })
  })
}





// WEBPACK FOOTER //
// ./src/utils/extension.js